import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Undo = createReactComponent("Undo", ["svg", defaultAttributes, [["polyline", {
  points: "2 10 2 16 8 16",
  key: "1rz5o0"
}], ["path", {
  d: "M22 16c-1.814-6.542-9.56-9.482-15.36-4.36L2 16",
  key: "dfj7rp"
}]]]);
export default Undo;